module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image16-c4ac9b63534ba996f0e8c4a040021f06.jpg";